import "./style.css";

const ActionButton = ({textColor, background, text, onClick}) => {
	return (
		<button className="action-button" style={{color: textColor, backgroundColor: background}} onClick={onClick}>{text}</button>
	)
}

export default ActionButton;
